import {
  JsonSchema,
  JsonSchemaItems,
  JsonSchemaProperty,
} from "../../../../types";
import { ChildCollection } from "../../../../types/types.export";

/**
 * Returns all child collections present in the schema.
 *
 * A child collection is identified as:
 *  - type = "array"
 *  - items.type = "object"
 */
export const getChildCollections = (schema: JsonSchema): ChildCollection[] => {
  return Object.entries(schema.properties).reduce<ChildCollection[]>(
    (collections, [field, property]) => {
      if (!isChildCollection(property)) {
        return collections;
      }

      collections.push({
        field,
        title: property.title,
        properties: property.items.properties ?? {},
        parentProperties: schema.properties,
      });

      return collections;
    },
    [],
  );
};

/**
 * Returns true if the schema contains at least one child collection.
 */
export const hasChildCollections = (schema: JsonSchema): boolean => {
  return getChildCollections(schema).length > 0;
};

/**
 * Determines whether a schema property represents
 * a child collection.
 */
const isChildCollection = (
  property: JsonSchemaProperty,
): property is JsonSchemaProperty & { items: JsonSchemaItems } => {
  if (property.type !== "array") {
    return false;
  }

  if (!property.items || Array.isArray(property.items)) {
    return false;
  }

  return property.items.type === "object" && "properties" in property.items;
};
